/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../../../app/bsky/actor/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'chat.bsky.actor.defs'

export { $nsid }

type ProfileViewBasic = {
  $type?: 'chat.bsky.actor.defs#profileViewBasic'
  did: l.DidString
  handle: l.HandleString
  displayName?: string
  avatar?: l.UriString
  associated?: ActorDefs.ProfileAssociated
  viewer?: ActorDefs.ViewerState
  labels?: LabelDefs.Label[]

  /**
   * Set to true when the actor cannot actively participate in conversations
   */
  chatDisabled?: boolean
  verification?: ActorDefs.VerificationState
}

export type { ProfileViewBasic }

const profileViewBasic = l.typedObject<ProfileViewBasic>(
  $nsid,
  'profileViewBasic',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    displayName: l.optional(l.string({ maxGraphemes: 64, maxLength: 640 })),
    avatar: l.optional(l.string({ format: 'uri' })),
    associated: l.optional(
      l.ref<ActorDefs.ProfileAssociated>(
        (() => ActorDefs.profileAssociated) as any,
      ),
    ),
    viewer: l.optional(
      l.ref<ActorDefs.ViewerState>((() => ActorDefs.viewerState) as any),
    ),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    chatDisabled: l.optional(l.boolean()),
    verification: l.optional(
      l.ref<ActorDefs.VerificationState>(
        (() => ActorDefs.verificationState) as any,
      ),
    ),
  }),
)

export { profileViewBasic }
